import { Component } from '@angular/core';

@Component({
  selector: 'nb-modal-body',
  templateUrl: './nb-modal-body.component.html',
  styleUrls: ['./nb-modal-body.component.scss'],
})
export class NbModalBodyComponent {}
